import React from 'react';
import ath from 'addToHomescreen';
import { ATHButton } from './buttons/ATHButton';

// Carlos M: writing my own React implementation of add-to-homescreen https://github.com/cubiq/add-to-homescreen
// no longer maintained and needed to have more control over the prompt to fix a bug

export class AddToHomeScreen extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            athCompatible: false
        }

        this.addtohome;
        this.showPrompt = this.showPrompt.bind(this);
    }

    componentDidMount() {
        this.addtohome = ath({
            appID: 'com.vin.' + pId + '.' + DocumentIDList, //setting unique appid for every homepage
            autostart: true, //Setting to false requires .show() to display.
            startDelay: 0, //Amount of seconds before the toaster displays.  default = 1
            maxDisplayCount: 1, //Number of times to show a particular visitor. 0 = infinite
            skipFirstVisit: false, //Display the next time they visit the site.
            lifespan: 30, //How long the toaster stays on screen in seconds.
            displayPace: 1, //How often to display in minutes.
            icon: false,
            logging: true
        });
        this.setCompatibility();
    }

    setCompatibility() {
        this.setState({
            athCompatible: ath.isCompatible ? true : false
        });
    }

    showPrompt() {
        this.addtohome.show(true);
    }

    render() {
        const athBtn = this.state.athCompatible ?
            <ATHButton showPrompt={this.showPrompt} /> : null;

        return (
            <React.Fragment>
                {athBtn}
            </React.Fragment>
        );

    }
 }